import { Box, Button, styled } from '@mui/material';

export const S = {
  Page: styled(Box)(({ theme }) => ({
    backgroundColor: '#282a37',
    height: '100vh',
    maxWidth: '100vw',
    color: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(to right,rgba(10, 14, 23, 0.95) 0%, rgba(10, 14, 23, 0.95) 60%, rgba(10, 14, 23, 0.6) 80%, rgba(10, 14, 23, 0) 100%), url(https://cdn.prod.website-files.com/62ce6663069946310f8f784a/66f16be88f29551e63efcb30_wind-mills-6928590_1280.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
  })),

  Hero: styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  })),

  Login: styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '10%',
    left: '5%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(25),
  })),

  Point: styled(Box)(({ theme }) => ({
    borderRadius: 100,
    padding: theme.spacing(0.9),
    backgroundColor: 'rgba(29, 144, 244, 1)',
    marginTop: '58px',
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
        opacity: 1,
      },
      '50%': {
        transform: 'scale(1.5)',
        opacity: 0.6,
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 1,
      },
    },
    animation: 'pulse 1.5s infinite',
  })),

  Button: styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1.5, 3),
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'rgba(29, 144, 244, 0.8)',
    },
    '& svg': {
      marginRight: theme.spacing(1),
    },
  })),

  Logo: styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: '3%',
    right: '3%',
  })),
};
